module.exports = __webpack_public_path__ + "static/media/chef-hat.3cb00b51.svg";